var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"finish"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.doFinish.apply(null, arguments)}}},[_vm._v(" おわる ")])])}
var staticRenderFns = []

export { render, staticRenderFns }